"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const dot = {
  background: 'interactive.primary.hover',
  boxShadow: [0, 0, 0, 2, 'background.default'],
  padding: 'zero',
  size: 8
};
const primary = {
  background: 'interactive.primary.hover',
  boxShadow: 'none',
  padding: 'xxsmall',
  size: 23
};
const theme = {
  dot,
  primary
};
exports.theme = theme;
//# sourceMappingURL=NotificationBadge.theme.js.map